import React from 'react';
import style from './NotificationsCard.module.css';
import notifIcon from '../../assets/notifIcon.svg'

const NotificationsCard = () => {
	return (
		<div className={style.NotificationsCard}>
			<img src={notifIcon} alt="" />

			<div className={style.NotificationsCardContent}>
				<span className={style.NotificationsCardTitle}>
					Buy Request from User
				</span>

				<span className={style.NotificationsCardText}>
					User has requested to buy 35 ETH via Bank transfer
				</span>
			</div>
		</div>
	)
}

export default NotificationsCard